/* import __COLOCATED_TEMPLATE__ from './chat-editor-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();